module.exports = __webpack_public_path__ + "static/media/The Dark Knight.04ef5d23.jpg";